import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// import './assets/css/theme_default.less'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import moment from 'moment'
import 'moment/locale/zh-cn'
import './assets/css/iconFont/iconfont.js'
import './assets/css/iconFont/icon.css'
import './assets/css/theme_light.less'
import './assets/css/iconFont/iconfont.css'
import config from '../public/js/config'
import VueClipboard from 'vue-clipboard2'
import Fragment from 'vue-fragment'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small', zIndex: 2000 })
Vue.component(CollapseTransition.name, CollapseTransition)
moment.locale('zh-cn') // 使用中文时间
Vue.prototype.$moment = moment
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.use(VueClipboard)
Vue.use(Fragment.Plugin)

Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.prototype.openLoading = function (message, target) {
  const loading = this.$loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    text: message || '拼命加载中', // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.6)', // 背景颜色
    body: true,
    target: target || document.body,
    customClass: 'el-loading-mask' // 遮罩层新增类名
  })
  return loading
}
Vue.prototype.is_xs = window.innerWidth < 768
Vue.prototype.is_sm = window.innerWidth >= 768 && window.innerWidth < 992
Vue.prototype.is_md = window.innerWidth >= 992 && window.innerWidth < 1200
Vue.prototype.is_lg = window.innerWidth >= 1200 && window.innerWidth < 1920
Vue.prototype.is_xl = window.innerWidth >= 1920

// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })

new Vue({
  router,
  store,
  render: h => h(App)
//   mounted () {
//     // You'll need this for renderAfterDocumentEvent.
//     document.dispatchEvent(new window.Event('render-event'))
//   }
}).$mount('#app')
